import { useContext } from "react";
import { OverettContext } from "../../../Context";
import OverettObject from "./OverettObject";
import "./OverettPanel.css";

const NewOverettPanel = () => {
    const overettContext = useContext(OverettContext);

    return (
        <div className="overett-panel">
            <h2>Opprett overett</h2>
            <div className=" flex-col small-gap">
                Velg to objekter å bruke i overetten.
                {overettContext?.overettObjects.value.upper && (
                    <>
                        <span>Øvre objekt valgt:</span>
                        <OverettObject
                            key={overettContext.overettObjects.value.upper.attributes.objectid}
                            object={overettContext.overettObjects.value.upper}
                            onRemove={() => {
                                overettContext?.overettObjects.set({
                                    upper: null,
                                    lower: overettContext.overettObjects.value.lower,
                                });
                            }}
                        />
                    </>
                )}
                {overettContext?.overettObjects.value.lower && (
                    <>
                        <span>Nedre objekt valgt:</span>
                        <OverettObject
                            key={overettContext.overettObjects.value.lower.attributes.objectid}
                            object={overettContext.overettObjects.value.lower}
                            onRemove={() => {
                                overettContext?.overettObjects.set({
                                    upper: overettContext.overettObjects.value.upper,
                                    lower: null,
                                });
                            }}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default NewOverettPanel;
